<!--
 * Description: 二级评论单元组件
-->

<template>
    <div class="unit-contaier">
        <div class="unit-title">
            <img :src=data.user.avatar :alt=data.user.username v-if="data.user && data.user.avatar"/>
            <img :alt=data.user.username src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAABECAMAAAAPzWOAAAAB5lBMVEUFa/4AAACuz/8Ibv6u0P+tz//w9v+51P/h7v6v0f+t0P+u0P+u0P9/tP+32P/F3f9BkP4Jb/+uz/8Vdv+u0P9Aj/6u0P+u0f+10/8pgv6u0P+TwP+v1P/i///n8f7C2v58sv5Gkv4jfv4ifv6rzv+t0P9Ol/6JuP+v0P+v0f/I2v+61//A2/+u0P8jfv+u0f8ziP+gyP9Gk/5cn/5fov+u0P+u0P+u0f+u0P+v0f+v0v+y1f/g7P9fov672P8RdP+tz/8pgf+kyf84iv1lpv5tqv+u0f+uz/+t0f+y0f+41v/////R5P/A2//C2/+62P+ny/+ZxP+Nvf+u0P+v0P+v0P+w0v+w0v+w0f+y0v+v0/+v0/+11v+y2P/i7//U5v/c6//R5P+Kuv9npf/H3//E3f8beP7F3f8McP+u0P8beP+Vwf9UnP6sz/+u0f/C2/+rzv+ly/+Zw/+Rvv59sv/K4f9Rmf5pqP83if4Mcf610/+vz//1+f9Nlf3E3P9ppv7f6//////0+P+lyv50rP7p8v/H3v6py/59sv5goP1Vmv2Ywv6BtP5ko/1bnf1Ql/1Nl/3R4/+Tvv2Dtv1Tmf3L4P/A2f/6/P6cxP6Ht/5wqv54r/3w9v/Z6P6uz/6iyP2bw/1vqf3GJSxAAAAAfHRSTlPMAMzMycr+BfrDt8admQ3z18fAvKOjcU/v0rOeKwP88uLX0dGyrZ+bi3sJ/sK5sqqppqGcm4d4bWlgNBP33MG/vK+pppqZg3dTKBkB6sjCua2gnJeTj1pHPDgvJCEW+vfz5eXe3dPQz8S9t6CdlGXx7Ovo5+Ld2djUxbpABVMc6wAABPZJREFUWMOtmGdfE0EQxs8NKUqMxIREJAkoFgxVpCgIqPTeQZq99153k5DQQkew92/qXFFv5y658NPn5WX437SduUXY9h+UBOKoHm4edB+8WVRiH6r0tvm3DmmrOkh4pdmHJ7cCqTl+gOjJbPdaU4RMetLlV/f2l2eWFrtcp0vLmrIV7I5WawqQoIzY3Z/pFDjVHzuaJmG8hpDqvQR0pgwIWrmaThHQ3cmkkGCLhMgUEsnZuEN005sEUuMGi1OHhGRy7jSDUaU/EWRCDOW2SzBQqZjjoaA+ZGw3VOSYYCxnNlDcDj3IBDC2ZwopaSdQ7FYtpAZiKTotpKhySEx+B4YE3ZB0YKSqRvDFgyFHIB8oFuOIXvOQUXiEcmqk2xC+Qw1xQAtlC1tTPfxNsxpSCT1Wr29ryssz6f+SCd6f/Qtph5Ol16dZuTk2CrLl5GYJWvVDt8gQJatHtTb7dlGVdu3TnsftiiuC4kgDtti/hyLt2a9TIfdviEfHkQwb1ciWgV2B0VMtQzogzbhFai1U0sx6QSxWsD5DJVlqkdlhQo7IkDEojQn5ITNml9aYpLWlWZmCfCkl5KZVgsAgOozyIcXydpkpWokztvxWigjlBYIYlSA7NGmVchoDLxStfp/9ydZiUnY1qa0UITUwAUx8bcE4usTUmrYULLClKPzAV7oB6iNCzmpqI/bHIuMVjkbibFHsF7734dxaAXKPkJ18n4LpO4b1+b0lzt7BT3zvwqhsA0g+IXe457lQ2QWm0Zupr6sLUOtczhgmpRcgdkJKuec5lM4xHa1PLbI5SnNwZk8ABBZ3Mff8HKXLepDwe8vqMqXnOOMmGHAAKSLExZ19aDKmq9DUPIOm40p5DHoWIND/3M7Mo/QDU4Sz8o19oDRPbX0IBjZA4DzfQJB5fcjnqTk2r4VUAAQa9hYK5xPT1+Im+4TCKZfDKSGEXxU2GmYJFaY2nNgqucQNqMTTiSHT+iWuwMsil37UB6xsrLKPqNn6CBkByAk8CbLoXKIS/4Buy8KzYAIg1fBVgw5gJEGJA9Mswh9AF4wAP0AchKQ70SiYZwk0j0ZBGSF2aShB35ehoRRKBAnt0QxZjwQ5DisUj8fpBLVB49EJ3zQ+CTIOcb1EgzqyolueSIZmk+5V9k4Jmiig2pBuMHhlZEOrKRAo8gG8tC/DTEVaKHiGjIrNhIwrEMduvM9Nj6I0EkYNH6GByxpHhpQ1KqW2V+3KNWmVW2Lxv4h4TNpnj7EjPhmiuNKoatmTVFY0tBHeZGwzvBGK/t7qqpcdJWRQ9ZEDWUkv/uPHeapWIEDVeqieAuY2FcTqht43KfnYRZPqksK4BdPsOPfhN572Z/tcogaSe+VGLyElVg4irjBSLoBefDGCnDeJ/vbB7vOh71h/PkQoHqH71FBP5ENDvJrP8qAdkntIyKDGOmkyAQMSgiDKx7258QFNQc/7gNGse1VpFy+xhTPGjAs9IsOPIIocEBF51WnEuAq1JVUdia5v1goCIXVbkiakR7RpTXYbbRXfUnc9kDCSbvFae9CX/ErbPkBA2wtP6iE6e0SE2WM1ulx3eKFKoLquTi6swJXCOiJqwJfKNd/qVa706YWFXVefXrx45XpXd52ZSBocS/UfDv6R/HSio6IW5AWCYAVHKvZygLSSlmpoDUMIlmN02HMkf+BuRWVVqw8lE0P+Xb8AUCCph/anQKAAAAAASUVORK5CYII=" v-else/>
            <span class="title"> {{data.user.username}}</span>
        </div>
        <div class="unit-body">
            <div class="text-area">
                <div class="unit-content" :class="{'text-control':fold}" ref="text" v-html="data.content"></div>
                <p class="fold pointer" v-if="needFold" @click="fold=!fold">{{fold?"展开":"收起"}}</p>
            </div>
            <comment 
                :id=id
                :data="data"
                :delOperation="true"
                :currentId=currentId
                @refresh=refresh
                @complain=complain
                @commitComment=commitComment>
                <template>
                    <div class="comment-list" v-if="data.subComment.length>0">
                        <div class="comment-unit" v-for="(item,index) in data.subComment" :key="'c_unit_'+index" >
                            <div class="unit-header">
                                <div class="unit-header-top">
									<img :src=item.user.avatar :alt=item.user.username v-if="item.user && item.user.avatar"/>
									<img :alt=item.user.username src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAABECAMAAAAPzWOAAAAB5lBMVEUFa/4AAACuz/8Ibv6u0P+tz//w9v+51P/h7v6v0f+t0P+u0P+u0P9/tP+32P/F3f9BkP4Jb/+uz/8Vdv+u0P9Aj/6u0P+u0f+10/8pgv6u0P+TwP+v1P/i///n8f7C2v58sv5Gkv4jfv4ifv6rzv+t0P9Ol/6JuP+v0P+v0f/I2v+61//A2/+u0P8jfv+u0f8ziP+gyP9Gk/5cn/5fov+u0P+u0P+u0f+u0P+v0f+v0v+y1f/g7P9fov672P8RdP+tz/8pgf+kyf84iv1lpv5tqv+u0f+uz/+t0f+y0f+41v/////R5P/A2//C2/+62P+ny/+ZxP+Nvf+u0P+v0P+v0P+w0v+w0v+w0f+y0v+v0/+v0/+11v+y2P/i7//U5v/c6//R5P+Kuv9npf/H3//E3f8beP7F3f8McP+u0P8beP+Vwf9UnP6sz/+u0f/C2/+rzv+ly/+Zw/+Rvv59sv/K4f9Rmf5pqP83if4Mcf610/+vz//1+f9Nlf3E3P9ppv7f6//////0+P+lyv50rP7p8v/H3v6py/59sv5goP1Vmv2Ywv6BtP5ko/1bnf1Ql/1Nl/3R4/+Tvv2Dtv1Tmf3L4P/A2f/6/P6cxP6Ht/5wqv54r/3w9v/Z6P6uz/6iyP2bw/1vqf3GJSxAAAAAfHRSTlPMAMzMycr+BfrDt8admQ3z18fAvKOjcU/v0rOeKwP88uLX0dGyrZ+bi3sJ/sK5sqqppqGcm4d4bWlgNBP33MG/vK+pppqZg3dTKBkB6sjCua2gnJeTj1pHPDgvJCEW+vfz5eXe3dPQz8S9t6CdlGXx7Ovo5+Ld2djUxbpABVMc6wAABPZJREFUWMOtmGdfE0EQxs8NKUqMxIREJAkoFgxVpCgIqPTeQZq99153k5DQQkew92/qXFFv5y658NPn5WX437SduUXY9h+UBOKoHm4edB+8WVRiH6r0tvm3DmmrOkh4pdmHJ7cCqTl+gOjJbPdaU4RMetLlV/f2l2eWFrtcp0vLmrIV7I5WawqQoIzY3Z/pFDjVHzuaJmG8hpDqvQR0pgwIWrmaThHQ3cmkkGCLhMgUEsnZuEN005sEUuMGi1OHhGRy7jSDUaU/EWRCDOW2SzBQqZjjoaA+ZGw3VOSYYCxnNlDcDj3IBDC2ZwopaSdQ7FYtpAZiKTotpKhySEx+B4YE3ZB0YKSqRvDFgyFHIB8oFuOIXvOQUXiEcmqk2xC+Qw1xQAtlC1tTPfxNsxpSCT1Wr29ryssz6f+SCd6f/Qtph5Ol16dZuTk2CrLl5GYJWvVDt8gQJatHtTb7dlGVdu3TnsftiiuC4kgDtti/hyLt2a9TIfdviEfHkQwb1ciWgV2B0VMtQzogzbhFai1U0sx6QSxWsD5DJVlqkdlhQo7IkDEojQn5ITNml9aYpLWlWZmCfCkl5KZVgsAgOozyIcXydpkpWokztvxWigjlBYIYlSA7NGmVchoDLxStfp/9ydZiUnY1qa0UITUwAUx8bcE4usTUmrYULLClKPzAV7oB6iNCzmpqI/bHIuMVjkbibFHsF7734dxaAXKPkJ18n4LpO4b1+b0lzt7BT3zvwqhsA0g+IXe457lQ2QWm0Zupr6sLUOtczhgmpRcgdkJKuec5lM4xHa1PLbI5SnNwZk8ABBZ3Mff8HKXLepDwe8vqMqXnOOMmGHAAKSLExZ19aDKmq9DUPIOm40p5DHoWIND/3M7Mo/QDU4Sz8o19oDRPbX0IBjZA4DzfQJB5fcjnqTk2r4VUAAQa9hYK5xPT1+Im+4TCKZfDKSGEXxU2GmYJFaY2nNgqucQNqMTTiSHT+iWuwMsil37UB6xsrLKPqNn6CBkByAk8CbLoXKIS/4Buy8KzYAIg1fBVgw5gJEGJA9Mswh9AF4wAP0AchKQ70SiYZwk0j0ZBGSF2aShB35ehoRRKBAnt0QxZjwQ5DisUj8fpBLVB49EJ3zQ+CTIOcb1EgzqyolueSIZmk+5V9k4Jmiig2pBuMHhlZEOrKRAo8gG8tC/DTEVaKHiGjIrNhIwrEMduvM9Nj6I0EkYNH6GByxpHhpQ1KqW2V+3KNWmVW2Lxv4h4TNpnj7EjPhmiuNKoatmTVFY0tBHeZGwzvBGK/t7qqpcdJWRQ9ZEDWUkv/uPHeapWIEDVeqieAuY2FcTqht43KfnYRZPqksK4BdPsOPfhN572Z/tcogaSe+VGLyElVg4irjBSLoBefDGCnDeJ/vbB7vOh71h/PkQoHqH71FBP5ENDvJrP8qAdkntIyKDGOmkyAQMSgiDKx7258QFNQc/7gNGse1VpFy+xhTPGjAs9IsOPIIocEBF51WnEuAq1JVUdia5v1goCIXVbkiakR7RpTXYbbRXfUnc9kDCSbvFae9CX/ErbPkBA2wtP6iE6e0SE2WM1ulx3eKFKoLquTi6swJXCOiJqwJfKNd/qVa706YWFXVefXrx45XpXd52ZSBocS/UfDv6R/HSio6IW5AWCYAVHKvZygLSSlmpoDUMIlmN02HMkf+BuRWVVqw8lE0P+Xb8AUCCph/anQKAAAAAASUVORK5CYII=" v-else/>
									<!-- <img :src=data.user.avatar> -->
                                    <span style="font-weight:600">{{item.user.username}}</span>{{"\xa0\xa0"}}
                                    <span>回复</span>
                                    <span class="name" style="font-weight:600">@{{data.user.username}}</span>
                                </div>
								<div class="unit-text" v-html="item.content"></div>
                                <comment 
                                    :key="'second_unit_'+index" 
                                    :id=id
                                    :data="item"
                                    :delOperation="true"
                                    :currentId=currentId
                                    :reply="false"
                                    :needComplain="false"
                                    @refresh=refresh
                                    @commitComment=commitComment>
                                </comment>
                            </div>
                            <!-- <span v-if="data.user.userId == currentId" class="delete" @click="deleteComment(item.id)">删除</span> -->
                            
                            <!-- <comment 
                                v-for="(item,index) in data.subComment" 
                                :key="'second_unit_'+index" 
                                :id=id
                                :data="item"
                                :delOperation="true"
                                :currentId=currentId
                                :reply="false"
                                :needComplain="false"
                                @refresh=refresh
                                @commitComment=commitComment>
                            </comment> -->
                        </div>
                    </div>
                </template>
            </comment>
        </div>
    </div>
</template>

<script>
import { mapMutations } from 'vuex'
import comment from './detail-comment.vue';

export default {
    name : "comment-unit",
    components : {
        comment
    },
    props : {
        id : {
            type : String,
            default : ""
        },
        data : {
            type : Object,
            default : ()=>{
                return {
                    content : "",
                    id : "",
                    liks : "",
                    collections : "",
                    comments : "",
                    user : {
                        avatar : "",
                        userId : "",
                        username : ""
                    }
                }
            }
        },
        currentId : {
            type : [String,Number],
            default : ""
        },
    },
    data(){
        return {
            discussing : false,     //是否处于编写评论
            comment : "",            //评论内容
            count:"",
            star:"",
            needFold : false,           //是否需要展开/收起选项
            fold : false,                //默认收起
        }
    },
    mounted(){
        try{
            let height = this.$refs.text && this.$refs.text.clientHeight;
            if( height && height > 48 ){
                this.needFold = true;
                this.fold = true;
            }else{
                this.needFold = false;
                this.fold = false;
            }
        }catch(e){
            console.log(e)
        }
    },
    methods: {
        ...mapMutations(['SETMSGDIALOG']),
        deleteComment(commentId){
            const {id} = this;
            this.SETMSGDIALOG({
                title: '系统提示',
                message: '确定删除该该评论吗？',
                commit: () => {
                    this.$api.forum.comment({
                        id,commentId,content : "1",
                        action : "remove"
                    }).then(res=>{
                        this.$emit("refresh",true)
                        this.SETMSGDIALOG(null)
                    })
                }
            })
        },
        /**
         * @description 二级评论
         * @return void
         */
        commitComment(data){
            const {id} = this;
            const {id:commentId,comment:content} = data;
            this.$api.forum.comment({
                id,content,commentId,
                action : "add"
            }).then(res=>{
                this.$emit("refresh",true)
            })
        },

        complain(){
            const {data:{id}} = this;
            this.$emit("complain",id)
        },
        refresh(){
            this.$emit("refresh",true)
        }
    }

}
</script>

<style lang="scss" scoped>
    .unit-contaier {
        width: 100%;
		padding: 16px 0 0 0;
        .unit-title {
            display: flex;
            align-items: center;
            > img {
                width: 28px;
                height: 28px;
                border-radius: 50%;
				margin-right: 8px;
            }
            .title {
                font-size: 14px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #333333;
            }
        }
        .unit-body {
            padding: 6px 0 0 44px;
            .text-area {
                position: relative;
                .unit-content {
					font-size: 14px;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #333333;
					line-height: 24px;
                    &.text-control {
                        height:48px;
                        overflow: hidden;
                    }
                }
                .fold {
                    position: absolute;
                    right: 0;
                    bottom: 0;
                    width: 56px;
                    height: 28px;
					line-height: 28px;
                    background: linear-gradient(90deg, rgba(255,255,255,0.9) 0%, #FFFFFF 100%);
                    border-radius: 2px;
					text-align: center;
                }
            }
            
            .comment-list {
				padding: 0 0 0 0;
                .comment-unit {
					margin: 12px 0 0 0;
                    .unit-header {
						.unit-header-top{
							height: 20px;
							display: flex;
							align-items: center;
							img {
							    margin-right: 10px;
							    width: 20px;
							    height: 20px;
							    border-radius: 10px;
							}
							span {
							    &.name {
							        color: #2d7be7;
							    }
							}
						}   
						.comment-contaier{
							padding: 0 0 0 27px;
							/deep/.detail-operation{
								padding: 0;
							}
						}
                    }
                    .unit-text {
                        padding-left: 27px;
                        width:100%;
                        word-break: break-word;
						margin: 6px 0;
                    }
                }
            }
        }
    }
</style>